var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.297 1.457a6.667 6.667 0 117.407 11.086A6.667 6.667 0 013.297 1.457zm6.37 4.876h-2v-2a.667.667 0 00-1.333 0v2h-2a.667.667 0 000 1.334h2v2a.667.667 0 001.333 0v-2h2a.667.667 0 100-1.334z",
    fill: "#2B5FF5"
  })));
}
export default SvgPlusFilled;